// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAABmJLR0QA/wD/AP+gvaeTAAAANElEQVRoge3WwQ0AIAzEsCv77wxLIFoke4I8kwAAqSS7O+KG1R0AAADP2HgAAPiOjQcABjrSpwMHOlg7MAAAAABJRU5ErkJggg==", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* RadioOption CSS start */
.kore-chat-window .sdkAccount.accountBtn .accountIcon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 100% 100%;
  width: 21px;
  height: 21px;
  margin: -4px;
  display: block;
}

.kore-chat-window .kore-action-sheet .radioOptionsPickerContainer {
  height: 415px;
  overflow-y: auto;
}

.kore-chat-window .kore-action-sheet .radioOptionsPickerContainer .sdkFooterIcon.account {
  opacity: 0;
}

.kore-chat-window .kore-action-sheet .radioOptionsPickerContainer .radioOptionMenuHeader .closePicker {
  cursor: pointer;
  background: none;
  border: none;
  outline: none;
  position: absolute;
  top: 21px;
  right: 20px;
}

.kore-chat-window .kore-action-sheet .radioOptionsPickerContainer .radioOptionMenuHeader .radioOptionHeading {
  width: 160px;
  height: 20px;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 2;
  letter-spacing: normal;
  text-align: center;
  /* line-height: 2.5; */
  margin-left: 17px;
  color: #000000;
}

.kore-chat-window .radioOptionMenuPicker {
  height: calc(100% - 109px);
  padding: 0px 20px 0 20px;
  overflow-y: auto;
}

.kore-chat-window .kore-action-sheet.hide .radioOptionsPickerContainer .confirmBTN {
  opacity: 0;
  z-index: 2;
}

.kore-chat-window .kore-action-sheet .radioOptionsPickerContainer .confirmBTN {
  position: absolute;
  height: 54px;
  background: #009dab;
  bottom: 0;
  width: 100%;
  text-align: center;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  opacity: 1;
  line-height: 54px;
  transition: opacity 1.5s ease-in-out;
  -moz-transition: opacity 1.5s ease-in-out;
  -webkit-transition: opacity 1.5s ease-in-out;
}

.kore-chat-window .radioOptionMenuPicker .btnAccount {
  height: 50px;
  /* box-shadow: 0 1px 5px 0 rgba(179, 186, 200, 0.58); */
  background-color: #ffffff;
  border-radius: 10px;
  padding-left: 13px;
  cursor: pointer;
  margin-bottom: 10px;
  display: table;
}

.kore-chat-window .radioOptionMenuPicker .radioButton .btnAccount {
  position: relative;
  background-color: white;
}

.kore-chat-window .radioOptionMenuPicker .btnAccount {
  display: block;
  cursor: pointer;
  user-select: none;
}

.kore-chat-window .radioOptionMenuPicker .radioButton {
  /* display:table; */
  width: 61%;
}

.kore-chat-window .radioOptionMenuPicker .radioButton .radioValue {
  display: table-cell;
}

.kore-chat-window .radioOptionMenuPicker .radioButton .btnAccount input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.kore-chat-window .radioOptionMenuPicker .radioButton .btnAccount .checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 30px;
  width: 30px;
  background-color: #eee;
  border-radius: 50%;
  border: solid 1px #d8d8d8;
  background-color: #ffffff;
}

.kore-chat-window .radioOptionMenuPicker .radioButton .btnAccount input:checked ~ .checkmark {
  background-color: white;
}

.kore-chat-window .radioOptionMenuPicker .radioButton .btnAccount .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.kore-chat-window .radioOptionMenuPicker .radioButton .btnAccount input:checked ~ .checkmark:after {
  display: block;
}

.kore-chat-window .radioOptionMenuPicker .radioButton .btnAccount .checkmark:after {
  top: 7px;
  left: 7px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #007ee5;
}

.kore-chat-window .radioOptionMenuPicker .btnAccount .accountIcon {
  margin-right: 15px;
}

.kore-chat-window .radioOptionMenuPicker .btnAccount .radioOptionName {
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 80%;
  position: relative;
  padding-left: 40px;
  height: 20px;
  font-size: 15px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: -0.12px;
  color: #222222;
}

.kore-chat-window .radioOptionMenuPicker .btnAccount .radioOptionValue {
  padding-left: 40px;
  margin-top: 4px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
  height: 19px;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.58;
  letter-spacing: 2px;
  color: #677180;
}

/* RadioOption CSS end */`, "",{"version":3,"sources":["webpack://./src/plugins/v2Plugin/templates/radioOptionPicker/radioOptionPicker.scss"],"names":[],"mappings":"AAAA,0BAAA;AACA;EACI,yDAAA;EACA,0BAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;AACJ;;AACA;EACI,aAAA;EACA,gBAAA;AAEJ;;AAAA;EACI,UAAA;AAGJ;;AADA;EACI,eAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AAIJ;;AAFA;EACI,YAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;EAEA,cAAA;AAIJ;;AAFA;EACI,0BAAA;EACA,wBAAA;EACA,gBAAA;AAKJ;;AAHA;EACI,UAAA;EACA,UAAA;AAMJ;;AAJA;EACI,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;EACA,iBAAA;EACA,oCAAA;EACA,yCAAA;EACA,4CAAA;AAOJ;;AALA;EACI,YAAA;EACA,uDAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AAQJ;;AANA;EACI,kBAAA;EACA,uBAAA;AASJ;;AAPA;EACI,cAAA;EACA,eAAA;EACA,iBAAA;AAUJ;;AARA;EACI,mBAAA;EACA,UAAA;AAWJ;;AATA;EACI,mBAAA;AAYJ;;AAVA;EACI,kBAAA;EACA,UAAA;EACA,eAAA;AAaJ;;AAXA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;AAcJ;;AAZA;EACI,uBAAA;AAeJ;;AAbA;EACI,WAAA;EACA,kBAAA;EACA,aAAA;AAgBJ;;AAdA;EACI,cAAA;AAiBJ;;AAfA;EACI,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AAkBJ;;AAhBA;EACI,kBAAA;AAmBJ;;AAjBA;EACI,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;EACA,cAAA;AAoBJ;;AAlBA;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AAqBJ;;AAnBA,wBAAA","sourcesContent":["/* RadioOption CSS start */\n.kore-chat-window .sdkAccount.accountBtn .accountIcon {\n    background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAABmJLR0QA/wD/AP+gvaeTAAAANElEQVRoge3WwQ0AIAzEsCv77wxLIFoke4I8kwAAqSS7O+KG1R0AAADP2HgAAPiOjQcABjrSpwMHOlg7MAAAAABJRU5ErkJggg==\");\n    background-size: 100% 100%;\n    width: 21px;\n    height: 21px;\n    margin: -4px;\n    display: block;\n}\n.kore-chat-window .kore-action-sheet .radioOptionsPickerContainer {\n    height: 415px;\n    overflow-y: auto;\n}\n.kore-chat-window .kore-action-sheet .radioOptionsPickerContainer .sdkFooterIcon.account {\n    opacity: 0;\n}\n.kore-chat-window .kore-action-sheet .radioOptionsPickerContainer .radioOptionMenuHeader .closePicker {\n    cursor: pointer;\n    background: none;\n    border: none;\n    outline: none;\n    position: absolute;\n    top: 21px;\n    right: 20px;\n}\n.kore-chat-window .kore-action-sheet .radioOptionsPickerContainer .radioOptionMenuHeader .radioOptionHeading {\n    width: 160px;\n    height: 20px;\n    font-size: 20px;\n    font-weight: bold;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 2;\n    letter-spacing: normal;\n    text-align: center;\n    /* line-height: 2.5; */\n    margin-left: 17px;\n\n    color: #000000;\n}\n.kore-chat-window .radioOptionMenuPicker {\n    height: calc(100% - 109px);\n    padding: 0px 20px 0 20px;\n    overflow-y: auto;\n}\n.kore-chat-window .kore-action-sheet.hide .radioOptionsPickerContainer .confirmBTN {\n    opacity: 0;\n    z-index: 2;\n}\n.kore-chat-window .kore-action-sheet .radioOptionsPickerContainer .confirmBTN {\n    position: absolute;\n    height: 54px;\n    background: #009dab;\n    bottom: 0;\n    width: 100%;\n    text-align: center;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 500;\n    color: #fff;\n    opacity: 1;\n    line-height: 54px;\n    transition: opacity 1.5s ease-in-out;\n    -moz-transition: opacity 1.5s ease-in-out;\n    -webkit-transition: opacity 1.5s ease-in-out;\n}\n.kore-chat-window .radioOptionMenuPicker .btnAccount {\n    height: 50px;\n    /* box-shadow: 0 1px 5px 0 rgba(179, 186, 200, 0.58); */\n    background-color: #ffffff;\n    border-radius: 10px;\n    padding-left: 13px;\n    cursor: pointer;\n    margin-bottom: 10px;\n    display: table;\n}\n.kore-chat-window .radioOptionMenuPicker .radioButton .btnAccount {\n    position: relative;\n    background-color: white;\n}\n.kore-chat-window .radioOptionMenuPicker .btnAccount {\n    display: block;\n    cursor: pointer;\n    user-select: none;\n}\n.kore-chat-window .radioOptionMenuPicker .radioButton {\n    /* display:table; */\n    width: 61%;\n}\n.kore-chat-window .radioOptionMenuPicker .radioButton .radioValue {\n    display: table-cell;\n}\n.kore-chat-window .radioOptionMenuPicker .radioButton .btnAccount input {\n    position: absolute;\n    opacity: 0;\n    cursor: pointer;\n}\n.kore-chat-window .radioOptionMenuPicker .radioButton .btnAccount .checkmark {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 30px;\n    width: 30px;\n    background-color: #eee;\n    border-radius: 50%;\n    border: solid 1px #d8d8d8;\n    background-color: #ffffff;\n}\n.kore-chat-window .radioOptionMenuPicker .radioButton .btnAccount input:checked ~ .checkmark {\n    background-color: white;\n}\n.kore-chat-window .radioOptionMenuPicker .radioButton .btnAccount .checkmark:after {\n    content: \"\";\n    position: absolute;\n    display: none;\n}\n.kore-chat-window .radioOptionMenuPicker .radioButton .btnAccount input:checked ~ .checkmark:after {\n    display: block;\n}\n.kore-chat-window .radioOptionMenuPicker .radioButton .btnAccount .checkmark:after {\n    top: 7px;\n    left: 7px;\n    width: 14px;\n    height: 14px;\n    border-radius: 50%;\n    background: #007ee5;\n}\n.kore-chat-window .radioOptionMenuPicker .btnAccount .accountIcon {\n    margin-right: 15px;\n}\n.kore-chat-window .radioOptionMenuPicker .btnAccount .radioOptionName {\n    display: inline-block;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    width: 80%;\n    position: relative;\n    padding-left: 40px;\n    height: 20px;\n    font-size: 15px;\n    font-weight: bold;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.25;\n    letter-spacing: -0.12px;\n    color: #222222;\n}\n.kore-chat-window .radioOptionMenuPicker .btnAccount .radioOptionValue {\n    padding-left: 40px;\n    margin-top: 4px;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    width: 100%;\n    height: 19px;\n    font-size: 12px;\n    font-weight: normal;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.58;\n    letter-spacing: 2px;\n    color: #677180;\n}\n/* RadioOption CSS end */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
